import { render } from "./NewsSection.vue?vue&type=template&id=3d6d0901&scoped=true"
import script from "./NewsSection.vue?vue&type=script&lang=js"
export * from "./NewsSection.vue?vue&type=script&lang=js"

import "./NewsSection.vue?vue&type=style&index=0&id=3d6d0901&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6d0901"]])

export default __exports__